import http from './httpService';

export function getAllRevisions() {
  return http.get(`/revisions`);
}
export function getRevision(id) {
  return http.get(`/revisions/${id}`);
}
export function getRevisionByReferenceNumber(referenceNumber) {
  return http.get(`/revisions?referenceNumber.contains=${referenceNumber}`);
}

export function addRevision(data) {
  return http.post(`/revisions`, data);
}

export function deleteRevisions(id) {
  return http.delete(`/revisions/${id}`);
}
export function editRevisions(data) {
  return http.put(`/revisions`, data);
}
export function getAllRevisionScopes(id) {
  return http.get(`/revision-scopes?revisionTypeId.equals=${id}&size=10000`);
}
